export const NAME = "sellerOffers"
export const FIREBASE_PATH = "offers"
